import { createActions, handleActions } from 'redux-actions';
import { ALERT_SUCCESS_THEME } from '@coconut/constants/alertBannerThemes';

export const types = {
  SHOW_ALERT_BANNER: 'SHOW_ALERT_BANNER',
  HIDE_ALERT_BANNER: 'HIDE_ALERT_BANNER',
};

export const { showAlertBanner, hideAlertBanner } = createActions(
  {
    [types.SHOW_ALERT_BANNER]: ({ theme, message = '' }) => ({
      theme,
      message,
    }),
  },
  types.HIDE_ALERT_BANNER
);

const INIT_STATE = {
  showAlertBanner: false,
  message: '',
  theme: ALERT_SUCCESS_THEME,
};

const reducer = handleActions(
  {
    [types.SHOW_ALERT_BANNER]: (state, action) => {
      const { theme, message } = action.payload;

      return {
        ...state,
        theme,
        message,
        showAlertBanner: true,
      };
    },
    [types.HIDE_ALERT_BANNER]: (state) => ({
      ...state,
      ...INIT_STATE,
    }),
  },
  INIT_STATE
);

export default reducer;

export const getAlertMessage = (state) => state.alertBanner.message;
export const getAlertBannerStatus = (state) =>
  state.alertBanner.showAlertBanner;
export const getAlertTheme = (state) => state.alertBanner.theme;



// WEBPACK FOOTER //
// ./src/services/redux/alertBanner.js